module.exports = __webpack_public_path__ + "img/22.b52e0268.jpg";